<!--
Map screen
@author bmk11u, crm4f
-->
<template>
  <div id="contain" class="container">
    <Nav name="Map" v-bind:home="true" v-if="authenticated" />
    <Nav name="Map" v-if="!authenticated" />
    <GMapMap
      :center='{lat:55.872446, lng:-4.289041}'
      :zoom='15'
      class='mapCanvas'
      ref='mapRef'
      :options='{
        styles: getStyles(),
        fullscreenControl: false,
        mapTypeControl: true,
        mapTypeControlOptions: {
          position: google && google.maps.ControlPosition.TOP_LEFT,
          style: google && google.maps.MapTypeControlStyle.DROPDOWN_MENU
        },
        streetViewControl: true,
        zoomControl: true
      }'>
    </GMapMap>

    <h5 style="color:#003865;margin-top:12px;margin-left:24px;font-family:PTSans;font-weight:700;">Get directions from...</h5>
    <div class="list-group" style="margin-bottom:4px;">
      <router-link v-if="toType == 'R' && roomToRoom"
        class="buildingItem"
        :to="'roomfrom?buildingId=' + buildingId + '&toId=' + toId + '&toType=' + toType">
        Another room in this building
      </router-link>
      <router-link class="buildingItem"
        :to="'buildingfrom?buildingId=' + buildingId + '&toId=' + toId + '&toType=' + toType">
        Another building
      </router-link>
      <router-link v-if="geoLocationAvailable" class="buildingItem"
        :to="'directions?toId=' + toId + '&toType=' + toType + '&geoLatitude=' + geoLatitude + '&geoLongitude=' + geoLongitude">
        Current location
      </router-link>
    </div>
    <div class="pl-2 pb-2">
      <button class="copyLink" @click="copyLink" v-if="showCopyLink">Copy Link <font-awesome-icon icon="link" /></button>
      <button class="accessableLink" v-if="accessUrl" @click="goOut(accessUrl)">Accessibility Guide</button>
      <CopyComplete item="link" />
    </div>
    <div id="pusher"></div>
    <Footer active="notifications" v-if="authenticated"/>
  </div>
</template>

<script setup>
import axios from 'axios'
import CopyComplete from '@/components/CopyComplete.vue'
import ClipboardJS from 'clipboard'
import Footer from '@/components/FooterMenu.vue'
// import $cookies from 'vue-cookies'
import { useLocationsCommon } from '@/composables/LocationsCommon.js'
import { useMapCommon } from '@/composables/MapCommon.js'
import { useGeoCommon } from '@/composables/GeoCommon.js'
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

const map = ref(null)
const mapRef = ref(null)
const google = ref(null)
const buildingId = ref(null)
const toId = ref(null)
const toType = ref(null)
const roomToRoom = ref(false)
const accessUrl = ref(null)
const showCopyLink = ref(null)

const route = useRoute()

const { authenticated } = useLocationsCommon()
const { geoLatitude, geoLongitude, geoLocationAvailable  } = useGeoCommon()

const { 
  initOverlays,
  addMarker, 
  getStyles, 
} = useMapCommon()

onMounted(() => {
  toId.value = route.query.toId
  buildingId.value = route.query.buildingId
  toType.value = route.query.toType
  showCopyLink.value = process.env.VUE_APP_MODE !== 'hybrid' && ClipboardJS.isSupported()

  mapRef.value.$gmapApiPromiseLazy().then((gmapApi) => {
    google.value = gmapApi
  }).then(() => {
    // Wait for Google Maps to load
    mapRef.value.$mapPromise.then((mapResponse) => {
    let locationId = route.query.toId
    // Fetch data for location
    axios.get(process.env.VUE_APP_WS_URL + '/map/locations/' + locationId, { withCredentials: false })
      .then(response => {
        let location = response.data
        map.value = mapResponse
        roomToRoom.value = location.roomToRoom
        accessUrl.value = location.accessUrl
        // Show the entrance
        addMarker(map.value, google.value, location.locationName + ' Entrance', location.entrance.latLng.lat,
          location.entrance.latLng.lng, location.directions, true, true, null)
        // Show the actual location if specified
        if (location.latLng != null) {
          addMarker(map.value, google.value,  location.locationName, location.latLng.lat,
            location.latLng.lng, null, false, false, require('../../assets/room.png'))
        }
        // Initialise other overlays
        initOverlays(map.value, google.value)
      })
    })
  })
})

function copyLink () {
  var el = document.createElement('textarea')
  el.value = window.location.href
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el);
  alert('Link copied to clipboard.')
}

function goOut (url) {
  window.open(url)
}
</script>

<style scoped>
.copyLink {
  background-color:#003865;
  color:#ffffff;
  border: 1px solid #003865;
  border-radius:12px;
  height:36px;
  font-weight:700;
  font-family: PTSans;
  margin-left:12px;
}

.accessableLink {
  background-color:#ffffff;
  color:#003865;
  border: 1px solid #003865;
  border-radius:12px;
  height:36px;
  font-weight:700;
  font-family: PTSans;
  margin-left:12px;
}
</style>
